<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><g fill="#fff"><path d="M21.499 27.5h-6.5a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4l-5.5 5.5v3.5zm-5.5-5v1h4v-1zm0-3v1h8v-1zm0-3v1h8v-1z" fill="currentColor"/><path d="M30.02 20.003a2.126 2.126 0 0 1 0 3.007l-4.508 4.507-3.008.002.002-3.009 4.507-4.507a2.126 2.126 0 0 1 3.007 0z" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-step-project',
});
</script>
